import api from './api';

export const SpecializedServicesAPI = {
  getAll: (params = {}) => api.get('/api/v1/specialized_services', { params }),
  getOne: (id) => api.get(`/api/v1/specialized_services/${id}`),
  create: (data) => api.post('/api/v1/specialized_services', data),
  update: (id, data) => api.put(`/api/v1/specialized_services/${id}`, data),
  delete: (id) => api.delete(`/api/v1/specialized_services/${id}`),
  search: (query) => api.get('/api/v1/specialized_services/search', { params: { query } }),
  getByService: (service) => api.get('/api/v1/specialized_services/service', { params: { service } }),
};
